import { render, staticRenderFns } from "./ModalComentario.vue?vue&type=template&id=5fce01ea&scoped=true&"
import script from "./ModalComentario.vue?vue&type=script&lang=js&"
export * from "./ModalComentario.vue?vue&type=script&lang=js&"
import style0 from "./ModalComentario.vue?vue&type=style&index=0&id=5fce01ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce01ea",
  null
  
)

export default component.exports